import { Component } from "react";
import {
    View,
    Image,
    Dimensions,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Commons from "../utils/Commons";
import * as Animatable from "react-native-animatable";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let isMobile = false;
let scale = 1;
const imgSplashLogo = require("../images/SplashScreen/SplashLogo.png");
const imgSplash = require("../images/MyOrders/splashJDS.png");
const imgJoDrugStore = require("../images/SplashScreen/JordanDrugStore.png");
const imgJdsSplash = require("../../assets/jdsSplash.png");
class SplashScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fadeOut: false,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.fadeTimer = setTimeout(() => {
            this.setState({ fadeOut: true });
            // ClientHomePage renders this without navigation props and swaps it out itself.
            this.navTimer = setTimeout(() => {
                if (this.props.navigation) {
                    this.props.navigation.navigate("ClientHomePage");
                }
            }, 500);
        }, 2000);
    }

    componentWillUnmount() {
        clearTimeout(this.fadeTimer);
        clearTimeout(this.navTimer);
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={[styles.container, { justifyContent: 'center', alignItems: 'center' }]} >
                <View style={{ width, height }}>
                    {/* {Commons.loadFonts(this)} */}
                    {/* {Styles.renderVSeparator(0)} */}
                    {this.renderPart1Mobile()}
                </View>
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        height = Dimensions.get("window").height;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        width = Commons.getWidth();
        styles = this.styles();
        marginTop = 300;
        styles = this.styles();
        return (
            <View style={styles.container}>
                    {Commons.loadFonts(this)}
                    {this.renderPart1()}
            </View >
        );
    }

    renderArtwork = () => {
        return (
            <Animatable.View style={{ width, height }}
                animation={this.state.fadeOut ? "fadeOut" : "fadeIn"}>
                <Image source={imgJdsSplash} resizeMode="cover" style={{ width, height }} />
            </Animatable.View>
        )
    }

    renderPart1 = () => this.renderArtwork()

    renderPart1Mobile = () => this.renderArtwork()

    renderPart2 = () => {

    }

    renderPart2Mobile = () => { 

    }

    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
        }
    });
}



export default SplashScreen;
